import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FocusInputType, KeyValues5, KeyValueSet, LocalService, PurchaseEntryInitialization, Status } from 'src/service/local.service';
import { PurchaseEntryService } from 'src/service/purchase-entry.service';
import { SupplierService } from 'src/service/supplier.service';

@Component({
  selector: 'app-purchase-entry',
  templateUrl: './purchase-entry.component.html',
  styleUrl: './purchase-entry.component.scss'
})
export class PurchaseEntryComponent {
  @ViewChild('content_purchase_entry')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = '';
  @Input() id: string = ''; @Input() purchaseEntryTypes: KeyValueSet[] = [];
  isSkipSupplier: boolean = false;
  searchItems: KeyValues5[] = [];
  isShowSpinnerCount = 0;

  message: string = ''; isRedAlert: boolean = true;

  purchaseEntryInitialization: PurchaseEntryInitialization;

  elementIds: any = {
    title: 'txt_purchase_entry_title',
    supplier_dd: 'dd_purchase_entry_supplier',
    invoice_number: 'txt_purchase_entry_number',
    way_bill_number: 'txt_purchase_entry_way_bill_number',
    batch_number: 'txt_purchase_entry_batch_number',
    supplier_name: 'txt_purchase_entry_supplier_name',
    save: "btn_purchase_entry_save",
    entry_type: 'entry_type'
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private purchaseEntryService: PurchaseEntryService, private supplierService: SupplierService) {
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {

  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.purchaseEntryService.getPurchaseEntryInitialization(this.businessId, this.id).subscribe(result => {
      this.purchaseEntryInitialization = result;
      this.searchItems = this.purchaseEntryInitialization.suppliers;
      if (!result.purchaseEntry.key) {
        this.onLoadRefNumber();
      }
      setTimeout(() => {
        this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
      }, 100);
    });
  }

  onLoadRefNumber(isCallSave = false) {
    const oldValue = this.purchaseEntryInitialization.purchaseEntry.v7;
    this.purchaseEntryService.getNextPurchaseEntryReference(this.businessId).subscribe(result => {
      if (result.status == Status.Success) {
        this.purchaseEntryInitialization.purchaseEntry.v7 = result.id;
        if (oldValue == this.purchaseEntryInitialization.purchaseEntry.v3.trim()) {
          this.purchaseEntryInitialization.purchaseEntry.v3 = result.id;
        }
        if (isCallSave) {
          this.onSave();
        }
      }
    });
  }


  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        if (this.isSkipSupplier) {
          this.onRemoveSupplierId();
          this.localService.onFocusNextInput(this.elementIds.invoice_number, FocusInputType.TextBox);
        } else {
          this.localService.onFocusNextInput(this.elementIds.supplier_dd, FocusInputType.NgxDropDown);
        }
      } break;
      case 2: {
        //Save product
        this.onSave();
      } break;
    }
  }

  onSave() {
    if (this.doCheck()) {
      this.purchaseEntryService.savePurchaseEntry(this.purchaseEntryInitialization.purchaseEntry, this.isSkipSupplier).subscribe(result => {
        if (!this.purchaseEntryInitialization.purchaseEntry.key && result.status == Status.Duplicate && this.purchaseEntryInitialization.purchaseEntry.v7 == this.purchaseEntryInitialization.purchaseEntry.v3) {
          this.onLoadRefNumber(true);
        } else {
          this.localService.showInformationByStatus(result.status);
          switch (result.status) {
            case Status.Success: {
              this.onCloseTrigger();
            } break;
          }
        }
      });
    }
  }

  doCheck() {
    let message = '';
    this.isRedAlert = true;
    let wrapper = this.purchaseEntryInitialization.purchaseEntry;

    if (!this.isSkipSupplier && (!wrapper.v2 || !wrapper.v2.trim())) {
      message = this.localService.languageContent.purchase_entry.need_supplier;
      this.localService.onFocusNextInput(this.elementIds.supplier_dd, FocusInputType.NgxDropDown);
    }

    this.message = message;
    if (this.message != '') {
      //this.localService.showInformation(this.message, this.isRedAlert);
    }
    return message == '';
  }

  onQrScanned(value) {
    this.onSearch(value);
  }

  onRemoveSupplierId(isFocus = false) {
    this.purchaseEntryInitialization.purchaseEntry.v2 = '';
    this.searchItems = this.purchaseEntryInitialization.suppliers;
    this.onFillSupplierIfEmpty();
    if (isFocus) {
      this.localService.onFocusNextInput(this.elementIds.supplier_dd, FocusInputType.NgxDropDown);
    }
  }

  onFillSupplierIfEmpty() {
    if (this.purchaseEntryInitialization.suppliers.length == 0) {
      this.supplierService.getSearchedSuppliers(this.businessId).subscribe(result => {
        this.purchaseEntryInitialization.suppliers = result;
        this.searchItems = result;
      });
    }
  }

  onSearch(strSearchKey: string = '') {
    if (strSearchKey && strSearchKey.trim().length > 0) {
      this.isShowSpinnerCount++;
      this.supplierService.getSearchedSuppliers(this.businessId, strSearchKey).subscribe(result => {
        this.isShowSpinnerCount--;
        this.searchItems = result;
      });
    } else {
      this.searchItems = this.purchaseEntryInitialization.suppliers;
    }

    if (this.searchItems.length == 1 && this.searchItems[0].v4 == '1') {
      this.purchaseEntryInitialization.purchaseEntry.v2 = this.searchItems[0].key;
      this.localService.onFocusNextInput(this.elementIds.invoice_number, FocusInputType.TextBox);
    }
  }
}
